import React from 'react';
import { Icon } from './Icon.js';
export const IconEqualLessThan = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M5 21H19", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M5.53418 9.11719L3.87988 10L5.53418 10.8828L20.0049 18.5996V16.332L8.13086 10L20.0049 3.66699V1.40039L5.53418 9.11719Z", fill: "currentColor", "data-stroke": "none" })));
};
//# sourceMappingURL=IconEqualLessThan.js.map